import { HeroImageWrapper } from "../content/hero-image-wrapper";
import { CustomDesignCover } from "../content/custom-design-cover";

type Props = {
  withOverlay?: boolean;
  caption?: string;
  captionType?: "default" | "dark";
};

export const CustomDesignHeroImage = ({
  withOverlay,
  caption,
  captionType,
}: Props) => {
  return (
    <HeroImageWrapper
      caption={caption}
      captionType={captionType}
      withOverlay={withOverlay}
    >
      <CustomDesignCover />
    </HeroImageWrapper>
  );
};
